const VERSION = '0.24.23';
const CONFIG = 'prod';
const BDATE = '5.29.10.19';
export {VERSION};
export {CONFIG};
export {BDATE};

